import { type AlertButton } from 'react-native';

export default function showAlert(message: string, _title?: string, _buttons?: AlertButton[]) {
  // WIBNI we used `dialog` instead, allowing us to customize the alert popup
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dialog
  return alert(message);
}
